import React, { useEffect, useRef } from "react";
import styles from "./../../styles/resultrowanalytics.module.css";
import { TimeDiffDTO } from "../../../../services/resultWorker";

interface Props {
  diffData: TimeDiffDTO;
  isFirstRow: boolean;
}

const ResultRowAnalyticsPass = ({ diffData,isFirstRow }: Props) => {
    const tabRef = useRef<HTMLTableCellElement>(null); // Create a ref for the div
    useEffect(() => {
        if (diffData.closest && tabRef.current && isFirstRow) {
            tabRef.current.scrollIntoView({ block: 'nearest' });
            setTimeout(() => {
                if (tabRef.current) {
                  tabRef.current.scrollLeft -= 70;
                }
              }, 250); // You might need to adjust this delay
          }
    },[tabRef,tabRef.current])
    // console.log("reenderet");
  return (
    <td
    ref={tabRef} 
      className={styles.resultRowAnalyticsSplitTime}
      key={"bef_" + diffData.rnk}
    >
      <span className={styles.resultRowAnalyticsSplitTimeRank}>
        {diffData.text}
      </span>
      <span
        className={`${styles.resultRowAnalyticsSplitTimeTime} ${
          diffData.before
            ? styles.resultRowAnalyticsSplitTimePositive
            : styles.resultRowAnalyticsSplitTimeNegative
        }`}
      >
        {diffData.time}
      </span>
    </td>
  );
};

export default ResultRowAnalyticsPass;
